import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const superannuationModule = {
  namespaced: true,
  state() {
    return {
      superannuationdata: Object,
      selectedSuperannuation: Object,
      superannuationEntitiesInfo: Array,
      compareSuperannuations: Array,
      iceProjectionModel: Object,
      iceAPIResponse: Object,
      superChartModel: Object,
    };
  },
  mutations,
  actions,
  getters,
};

export default superannuationModule;
